import { fuelLevelsFrom } from '@relay-towing/ui';
import type { ChecklistItem } from '@/api/truckInspections';

/*
 * The two readings off the dash get the dash's own shape (REL-399). A fuel
 * question is a multiple choice that runs Empty to Full, and becomes a dial;
 * anything else multiple choice keeps its buttons. An odometer is a number
 * in miles or kilometres, and gets the big box with commas.
 *
 * Read from the question's wording for now. A renamed question falls back to
 * the plain controls, which is safe, just plainer.
 */

/** The dial's stops, emptiest first, or null for anything that is not fuel. */
export const fuelLevelsFor = (item: ChecklistItem) =>
  item.answerType === 'SELECT' && /fuel/i.test(item.label)
    ? fuelLevelsFrom(item.options)
    : null;

export const isOdometer = (item: ChecklistItem) =>
  item.answerType === 'NUMBER' &&
  (/odometer|mileage/i.test(item.label) ||
    ['mi', 'km'].includes((item.unit ?? '').trim().toLowerCase()));

/** The unit beside the box. A unit cleared in the builder comes back as ''. */
export const odometerUnit = (item: ChecklistItem) => item.unit?.trim() || 'mi';

/** Seven digits is 9,999,999: past any truck. */
const ODOMETER_DIGITS = 7;

/** What the draft keeps from whatever was typed: the bare digits. */
export const odometerDigits = (typed: string) =>
  typed.replace(/\D/g, '').slice(0, ODOMETER_DIGITS);

/** "84120" as "84,120". */
export const withCommas = (digits?: string) =>
  digits ? Number(digits).toLocaleString('en-US') : '';
